import React from "react";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { Flex, HelpIndicator, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import {
  count,
  helpIcon,
  labelCluster,
  labelText,
  labelWithIcon,
  legendSwatchColorVar,
  row,
  swatch,
} from "./styles_vanilla.css";

export const DonutLegendItem = ({
  color,
  label,
  count: itemCount,
  tooltip,
}: {
  color: string;
  label: string;
  count: number;
  tooltip?: string;
}) => {
  return (
    <Flex className={row}>
      <Flex className={labelCluster}>
        <div
          className={swatch}
          style={assignInlineVars({ [legendSwatchColorVar]: color })}
          aria-hidden="true"
        />
        <Flex className={labelWithIcon}>
          <Text variant="regular-md" className={labelText}>
            {label}
          </Text>
          {tooltip && (
            <HelpIndicator id="donut-legend-item-tooltip" content={tooltip} placement="top">
              <Icon type="question-circle" variant="solid" className={helpIcon} />
            </HelpIndicator>
          )}
        </Flex>
      </Flex>
      <Text variant="strong-md" className={count}>
        {itemCount.toLocaleString()}
      </Text>
    </Flex>
  );
};
